var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"mission-term-parts"},[_c('p',{staticClass:"mission-term-parts__title"},[_vm._v(_vm._s(_vm.mission.missionTermTitle))]),_c('p',{staticClass:"mission-term-parts__term"},[_vm._v(_vm._s(_vm.mission.missionTerm))])])}
var staticRenderFns = []

export { render, staticRenderFns }